import RoutesInApp from "./router/route";
import "react-block-ui/style.css";
import "./index.css";
// RoutesComponent
import { Routes, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import configureStore from "store/configureStore";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./themes";
import { Provider } from "react-redux";
import Template from "./components/Common/ElementInForm/TemplateDialog";
import ReduxBlockUi from "react-block-ui/redux";
import "aos/dist/aos.css";
import "./Loader.css"
import { useState } from "react";

const history = createBrowserHistory({ window: window });
// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

const App: React.FC = () => {

  const [IsRefresh, setIsRefresh] = useState(false) as any
  return (
    <Provider store={store}>
      <ReduxBlockUi
        tag="div"
        block="BLOCK_UI"
        unblock={["UNBLOCK_UI", /fail/i]}
        loader={
          <div className="spinner">
            <span className="ball-1"></span>
            <span className="ball-2"></span>
            <span className="ball-3"></span>
            <span className="ball-4"></span>
            <span className="ball-5"></span>
            <span className="ball-6"></span>
            <span className="ball-7"></span>
            <span className="ball-8"></span>
          </div>
        }
      >
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes >
            {RoutesInApp.map((o) => {
              return (
                <Route path={o.path} key={o.path} element={o.layout ? (
                  <o.layout propLayout={o.propLayout} IsRefresh={IsRefresh} setIsRefresh={setIsRefresh}>
                    {o.component ? <o.component /> : null}
                    <Template />
                  </o.layout>
                ) :
                  (o.component ? <o.component /> : null)} />
              );
            })}
          </Routes>
        </ThemeProvider>
      </ReduxBlockUi>
    </Provider>
  );
};

export default App;